/* eslint-disable class-methods-use-this */
import DirectoryService from './DirectoryService';

export default class MultiDomainDirectoryService implements DirectoryService {
  readonly name = 'Multi-Domain';

  canChangeRsvp = () => true;

  showEmployeeDirectoryIntegrationErrorInOrgCalendarPreference = () => false;
}
